var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"body-class":"img-preview","content-class":"no-footer","id":"image-preview","hide-footer":"","size":"lg","title-html":"[timestamp] <small>Front Photo</small>"}},[_c('img',{attrs:{"src":"https://images.unsplash.com/photo-1560617544-b4f287789e24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2849&q=80"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }